import {
  kBiVizStyleDefaults,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kFills: Array<{ value: number; label: string }> = [
  { value: 0, label: '不填充' },
  { value: 0.1, label: '淡' },
  { value: 0.2, label: '适中' },
  { value: 0.4, label: '较深' },
  { value: 0.6, label: '深' },
];

/** How deeply each polygon is filled. */
export const RadarOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const radar = style?.radar ?? kBiVizStyleDefaults.radar;
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.radar}
      onReset={
        style?.radar
          ? () => onChange(biWithStyleOption(style, 'radar', undefined))
          : null
      }
    >
      <StyleRow label="填充">
        {kFills.map(fill => (
          <BiChip
            key={fill.value}
            label={fill.label}
            selected={Math.abs(radar.fillOpacity - fill.value) < 0.05}
            onPress={() =>
              onChange(
                biWithStyleOption(style, 'radar', { fillOpacity: fill.value }),
              )
            }
          />
        ))}
      </StyleRow>
    </StyleGroup>
  );
});
